import Main from "@/view/main.vue";

export const topRouter = {
  path: "/",
  name: "",
  component: Main,
  redirect: "",
  children: [
    // 首页
    { path: "", name: "home", component: () => import("@/view/home/index") },
    // 产品资源
    {
      path: "/resource",
      name: "resource",
      component: () => import("@/view/resource/index"),
      redirect: "/product/index",
      children: [
        // TEMP
        { path: "Conference", name: "resource_Conference", component: () => import("@/view/resource/components/Conference") }, //发布会
        // { path: 'SDWANSummit', name: 'resource_SDWANSummit', component: () => import('@/view/resource/components/SDWANSummit') }, //sdwan峰会
        // { path: 'CBEcommerce', name: 'resource_CBEcommerce', component: () => import('@/view/resource/components/CBEcommerce') }, //跨境电商
        // { path: 'tempPage', name: 'resource_tempPage', component: () => import('@/view/resource/components/tempPage') }, //linkwan渠道伙伴

        // 云
        { path: "CloudMSP", name: "resource_CloudMSP", component: () => import("@/view/resource/components/CloudMSP") },
        { path: "CubeCloud", name: "resource_CubeCloud", component: () => import("@/view/resource/components/CubeCloud") },
        { path: "CloudServices", name: "resource_CloudServices", component: () => import("@/view/resource/components/CloudServices") },
        { path: "CloudLinkCloud", name: "resource_CloudLinkCloud", component: () => import("@/view/resource/components/CloudLinkCloud") },
        { path: "SafetyRule", name: "resource_safetyRule", component: () => import("@/view/resource/components/safetyRule") },
        { path: "InfoSecurity", name: "resource_InfoSecurity", component: () => import("@/view/resource/components/InfoSecurity") },
        // { path: 'HybridCloud', name: 'resource_HybridCloud', component: () => import('@/view/resource/components/HybridCloud') },
        { path: "BigData", name: "resource_BigData", component: () => import("@/view/resource/components/BigData") },
        { path: "DisasterRecovery", name: "resource_DisasterRecovery", component: () => import("@/view/resource/components/DisasterRecovery") },
        { path: "Desktop", name: "resource_Desktop", component: () => import("@/view/resource/components/Desktop") },
        { path: "CloudStorage", name: "resource_CloudStorage", component: () => import("@/view/resource/components/CloudStorage") },

        // 网
        // { path: 'Sdwan', name: 'resource_Sdwan', component: () => import('@/view/resource/components/Wanact') },
        { path: "WanCCS", name: "resource_WanCCS", component: () => import("@/view/resource/components/WanCCS") },
        { path: "WanDCS", name: "resource_WanDCS", component: () => import("@/view/resource/components/WanDCS") },
        { path: "WanAccelerator", name: "resource_WanAccelerator", component: () => import("@/view/resource/components/WanAccelerator") },
        // { path: 'WanEquipment', name: 'resource_WanEquipment', component: () => import('@/view/resource/components/WanEquipment') },

        //IDC
        { path: "IdcCoop", name: "resource_IdcCoop", component: () => import("@/view/resource/components/IdcCoop") },
        { path: "IdcStaVaServices", name: "resource_IdcStaVaServices", component: () => import("@/view/resource/components/IdcStaVaServices") },
        { path: "IdcServiceModels", name: "resource_IdcServiceModels", component: () => import("@/view/resource/components/IdcServiceModels") },
        { path: "IdcDataCenter", name: "resource_IdcDataCenter", component: () => import("@/view/resource/components/IdcDataCenter") },
        { path: "MdcHG", name: "resource_MdcHG", component: () => import("@/view/resource/components/MdcHangGang") },
        // { path: 'IdcSCDataCenter', name: 'resource_IdcSCDataCenter', component: () => import('@/view/resource/components/IdcSCDataCenter') },
        { path: "IdcFudi", name: "resource_IdcFudi", component: () => import("@/view/resource/components/IdcFudi") },
        { path: "IdcXiaSha", name: "resource_IdcXiaSha", component: () => import("@/view/resource/components/IdcXiaSha") },
        { path: "IdcJianDe", name: "resource_IdcJianDe", component: () => import("@/view/resource/components/IdcJianDe") },
        { path: "IdcJianDeNew", name: "resource_IdcJianDe_new", component: () => import("@/view/resource/components/IdcJianDeNew") },
        { path: "ComputePower", name: "resource_ComputePower", component: () => import("@/view/resource/components/ComputePower") }, //算力服务
        // 其余弃用
        // { path: 'Idcdesign', name: 'resource_Idcdesign', component: () => import('@/view/resource/components/Idcdesign') },
        // { path: 'MdcTfk', name: 'resource_MdcTfk', component: () => import('@/view/resource/components/MdcTfk') },
        // { path: 'MdcPbb', name: 'resource_MdcPbb', component: () => import('@/view/resource/components/MdcPbb') },
        // { path: 'MdcCustom', name: 'resource_MdcCustom', component: () => import('@/view/resource/components/MdcCustom') },
        // { path: 'Idcoperation', name: 'resource_Idcoperation', component: () => import('@/view/resource/components/Idcoperation') },
        // { path: 'LinkCloudMsp', name: 'resource_LinkCloudMsp', component: () => import('@/view/resource/components/LinkCloudMsp') },
        // { path: 'LinkCloudMdc', name: 'resource_LinkCloudMdc', component: () => import('@/view/resource/components/LinkCloudMdc') },
        // { path: 'Paasconc', name: 'resource_Paasconc', component: () => import('@/view/resource/components/Paasconc') },
        // { path: 'MdcCloud', name: 'resource_MdcCloud', component: () => import('@/view/resource/components/MdcCloud') },
        // { path: 'Wanser', name: 'resource_Wanser', component: () => import('@/view/resource/components/Wanser') },
        // { path: 'Wanscen', name: 'resource_Wanscen', component: () => import('@/view/resource/components/Wanscen') },
        // 总部 IDC
        // { path: 'Idcsales', name: 'resource_Idcsales', component: () => import('@/view/resource/components/Idcsales') },
        // // 总部 云网融合
        // { path: 'Cnnglobal', name: 'resource_Cnnglobal', component: () => import('@/view/resource/components/Cnnglobal') },
        // { path: 'Cnnhangzhou', name: 'resource_Cnnhangzhou', component: () => import('@/view/resource/components/Cnnhangzhou') },
        // { path: 'Cnnhighspeed', name: 'resource_Cnnhighspeed', component: () => import('@/view/resource/components/Cnnhighspeed') },
        // // 领云 IaaS
        // { path: 'iaaspubc', name: 'resource_Iaaspubc', component: () => import('@/view/resource/components/Iaaspubc') },
        // { path: 'iaaspvac', name: 'resource_Iaaspvac', component: () => import('@/view/resource/components/Iaaspvac') },
        // { path: 'iaasmixc', name: 'resource_Iaasmixc', component: () => import('@/view/resource/components/Iaasmixc') },
        // // 领云 PaaS
        // { path: 'paasmidc', name: 'resource_Paasmidc', component: () => import('@/view/resource/components/Paasmidc') },
        // { path: 'paasspas', name: 'resource_Paasspas', component: () => import('@/view/resource/components/Paasspas') },
        // // 领云 解决方案
        // { path: 'rsvcloud', name: 'resource_Rsvcloud', component: () => import('@/view/resource/components/Rsvcloud') },
        // { path: 'rsvsafe', name: 'resource_Rsvsafe', component: () => import('@/view/resource/components/Rsvsafe') },
        // { path: 'rsvdaba', name: 'resource_Rsvdaba', component: () => import('@/view/resource/components/Rsvdaba') },
        // { path: 'rsviflize', name: 'resource_Rsviflize', component: () => import('@/view/resource/components/Rsviflize') },
        // // 混合云
        // { path: 'Container', name: 'resource_Container', component: () => import('@/view/resource/components/Container') },
        // // 全球网络
        // { path: 'International', name: 'resource_International', component: () => import('@/view/resource/components/International') },
        // { path: 'Sdwan', name: 'resource_Sdwan', component: () => import('@/view/resource/components/Sdwan') },
        // { path: 'Protocol', name: 'resource_Protocol', component: () => import('@/view/resource/components/Protocol') },
        // // 数据中心
        // { path: 'Internal', name: 'resource_Internal', component: () => import('@/view/resource/components/Internal') },
        // { path: 'Global', name: 'resource_Global', component: () => import('@/view/resource/components/Global') },
      ],
    },
    // 解决方案
    {
      path: "/solution",
      name: "solution",
      component: () => import("@/view/solution/index"),
      redirect: "/solution/index",
      children: [
        // 产品安全池
        { path: "SecurityPool", name: "solution_SecurityPool", component: () => import("@/view/solution/components/SecurityPool") },
        // 云原生
        { path: "ConAndMix", name: "solution_ConAndMix", component: () => import("@/view/solution/components/ConAndMix") },
        { path: "DevOps", name: "solution_DevOps", component: () => import("@/view/solution/components/DevOps") },
        { path: "Containerization", name: "solution_Containerization", component: () => import("@/view/solution/components/Containerization") },
        // NaaS
        { path: "BranchNetWork", name: "solution_BranchNetWork", component: () => import("@/view/solution/components/BranchNetWork") },
        { path: "SaaSApp", name: "solution_SAASAPP", component: () => import("@/view/solution/components/SaaSApp") },
        { path: "UpToCloud", name: "solution_UpToCloud", component: () => import("@/view/solution/components/UpToCloud") },
        { path: "CombinNet", name: "solution_CombinNet", component: () => import("@/view/solution/components/CombinNet") },
        { path: "InternetoF", name: "solution_InternetoF", component: () => import("@/view/solution/components/InternetoF") },
        // Cloud MSP
        { path: "Database", name: "solution_Database", component: () => import("@/view/solution/components/Database") },
        { path: "EntSecurity", name: "solution_EntSecurity", component: () => import("@/view/solution/components/EntSecurity") },
        // 其他
        { path: "CloudAndNet", name: "solution_CloudAndNet", component: () => import("@/view/solution/components/CloudAndNet") },
        { path: "Blockchain", name: "solution_Blockchain", component: () => import("@/view/solution/components/Blockchain") },
        // 行业
        { path: "DCmove", name: "solution_DCmove", component: () => import("@/view/solution/components/DCmove") }, //机房搬迁解决方案
        { path: "maintenanceService", name: "solution_maintenanceService", component: () => import("@/view/solution/components/maintenanceService") }, //全方位运维服务解决方案
        { path: "equalGuarantee", name: "solution_equalGuarantee", component: () => import("@/view/solution/components/equalGuarantee") }, //等保测评解决方案
        { path: "dataCenter", name: "solution_dataCenter", component: () => import("@/view/solution/components/dataCenter") }, //等保测评解决方案
        { path: "ComputePower", name: "solution_ComputePower", component: () => import("@/view/solution/components/ComputePower") }, //算力服务方案

        // { path: 'Ecommerce', name: 'solution_Ecommerce', component: () => import('@/view/solution/components/Ecommerce') },
        // { path: 'MixCloud', name: 'solution_MixCloud', component: () => import('@/view/solution/components/MixCloud') },
        // { path: 'Container', name: 'solution_Container', component: () => import('@/view/solution/components/Container') },
        // { path: 'GlobalNet', name: 'solution_GlobalNet', component: () => import('@/view/solution/components/GlobalNet') },
      ],
    },
    // 管理服务
    {
      path: "/service",
      name: "service",
      component: () => import("@/view/service/index"),
      redirect: "/service/index",
      children: [
        // IDC托管
        { path: "Idc", name: "service_Idc", component: () => import("@/view/service/components/Idc") },
        // 云管理
        { path: "Advisory", name: "service_Advisory", component: () => import("@/view/service/components/Advisory") },
        { path: "Entrust", name: "service_Entrust", component: () => import("@/view/service/components/Entrust") },
        { path: "Migrate", name: "service_Migrate", component: () => import("@/view/service/components/Migrate") },
        { path: "Compliance", name: "service_Compliance", component: () => import("@/view/service/components/Compliance") },
        // 企业组网
        { path: "Consultative", name: "service_Consultative", component: () => import("@/view/service/components/Consultative") },
        { path: "Implement", name: "service_Implement", component: () => import("@/view/service/components/Implement") },
      ],
    },
    // 客户案例
    { path: "/cases", name: "cases", component: () => import("@/view/cases/index") },
    // 合作伙伴
    { path: "/partners", name: "partners", component: () => import("@/view/partners/index") },
    { path: "/wanPartners", name: "wanPartners", component: () => import("@/view/partners/wanPartners") },
    { path: "/linkWanPartnerArc", name: "linkWanPartnerArc", component: () => import("@/view/partners/linkwanPartner/partnerArc") },
    { path: "/linkWanPartnerPol", name: "linkWanPartnerPol", component: () => import("@/view/partners/linkwanPartner/partnerPol") },
    { path: "/linkWanPartnerSup", name: "linkWanPartnerSup", component: () => import("@/view/partners/linkwanPartner/partnerSup") },
    // 关于网银

    {
      path: "/about",
      name: "about",
      component: () => import("@/view/about/index"),
      redirect: "/about/index",
      children: [
        // 企业介绍
        { path: "Introduction", name: "about_introduction", component: () => import("@/view/about/components/Introduction") },
        // 加入我们
        { path: "Join", name: "about_join", component: () => import("@/view/about/components/Join") },
        //新闻中心
        { path: "News", name: "about_news", component: () => import("@/view/about/components/News") },
        // 新闻详情
        { path: "NewsDetail", name: "about_newsdet", component: () => import("@/view/about/components/NewsDetail") },
      ],
    },
    { path: "/documents", name: "documents", component: () => import("@/view/documents/index") },

    // 移动端
    {
      path: "/mobResource",
      name: "mobResource",
      component: () => import("@/view/mobResource/index"),
      redirect: "/mobResource/index",
      children: [
        // 网
        // { path: 'netSDWAN', name: 'mobResource_netSDWAN', component: () => import('@/view/mobResource/components/netSDWAN') },
        { path: "netDCS", name: "mobResource_netDCS", component: () => import("@/view/mobResource/components/netDCS") },
        { path: "netCCS", name: "mobResource_netCCS", component: () => import("@/view/mobResource/components/netCCS") },
        // 云
        { path: "cloudService", name: "mobResource_cloudService", component: () => import("@/view/mobResource/components/cloudService") },
        { path: "cloudDesktop", name: "mobResource_cloudDesktop", component: () => import("@/view/mobResource/components/cloudDesktop") },
        { path: "cloudStorage", name: "mobResource_cloudStorage", component: () => import("@/view/mobResource/components/cloudStorage") },
        { path: "cloudBigData", name: "mobResource_cloudBigData", component: () => import("@/view/mobResource/components/cloudBigData") },
        { path: "cloudRecovery", name: "mobResource_cloudRecovery", component: () => import("@/view/mobResource/components/cloudRecovery") },
        { path: "cloudMSP", name: "mobResource_cloudMSP", component: () => import("@/view/mobResource/components/cloudMSP") },
        { path: "cloudPass", name: "mobResource_cloudPass", component: () => import("@/view/mobResource/components/cloudPass") },
        { path: "cloudSafetyRule", name: "mobResource_cloudSafetyRule", component: () => import("@/view/mobResource/components/cloudSafetyRule") },
        { path: "cloudSecurityPool", name: "mobResource_cloudSecurityPool", component: () => import("@/view/mobResource/components/cloudSecurityPool") },
        { path: "cloudInfoSecurity", name: "mobResource_cloudInfoSecurity", component: () => import("@/view/mobResource/components/cloudInfoSecurity") },
        { path: "cloudLinkCloud", name: "mobResource_cloudLinkCloud", component: () => import("@/view/mobResource/components/cloudLinkCloud") },
        // MDC
        { path: "mdcDataCenter", name: "mobResource_mdcDataCenter", component: () => import("@/view/mobResource/components/mdcDataCenter") },
        { path: "idcJianDeNew", name: "mobResource_idcJianDe", component: () => import("@/view/mobResource/components/IdcJianDeNew") },
        { path: "mdcHangGang", name: "mobResource_mdcHangGang", component: () => import("@/view/mobResource/components/mdcHangGang") },
        { path: "mdcServiceModels", name: "mobResource_mdcServiceModels", component: () => import("@/view/mobResource/components/mdcServiceModels") },
        { path: "mdcStaVaServices", name: "mobResource_mdcStaVaServices", component: () => import("@/view/mobResource/components/mdcStaVaServices") },
        { path: "mdcCoop", name: "mobResource_mdcCoop", component: () => import("@/view/mobResource/components/mdcCoop") },
        { path: "theConference", name: "mobResource_theConference", component: () => import("@/view/mobResource/components/theConference") },
        // { path: 'mdcSCDataCenter', name: 'mobResource_mdcSCDataCenter', component: () => import('@/view/mobResource/components/mdcSCDataCenter') },
        // 解决方案
        { path: "solBranchNetWork", name: "mobResource_solBranchNetWork", component: () => import("@/view/mobResource/components/solaBranchNetWork") },
        { path: "solSaaSApp", name: "mobResource_solSaaSApp", component: () => import("@/view/mobResource/components/solaSaaSApp") },
        { path: "solUpToCloud", name: "mobResource_solUpToCloud", component: () => import("@/view/mobResource/components/solaUpToCloud") },
        { path: "solCalculate", name: "mobResource_solCalculate", component: () => import("@/view/mobResource/components/solCalculate") },
        // 行业
        { path: "DCmaintenance", name: "mobResource_DCmaintenance", component: () => import("@/view/mobResource/components/DCmaintenance") },
        { path: "DCmove", name: "mobResource_DCmove", component: () => import("@/view/mobResource/components/DCmove") },
        { path: "DCcustomized", name: "mobResource_DCcustomized", component: () => import("@/view/mobResource/components/DCcustomized") },
        { path: "MobEqualGuarantee", name: "mobResource_MobEqualGuarantee", component: () => import("@/view/mobResource/components/MobEqualGuarantee") },

        //关于网银
        { path: "MobIntroduction", name: "mobResource_MobIntroduction", component: () => import("@/view/mobResource/components/MobIntroduction") },
        { path: "MobJoin", name: "mobResource_MobJoin", component: () => import("@/view/mobResource/components/MobJoin") },
      ],
    },
  ],
};
const page404 = {
  path: "/*",
  name: "error-404",
  meta: {
    setTitle: "页面不存在",
    visitor: true,
  },
  component: () => import("@/view/error-page/404.vue"),
};

export const routers = [topRouter, page404];



// WEBPACK FOOTER //
// ./src/router/router.js